import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environment';
import { Credentials, CredentialsFetcher } from '@wizbii/algolia';
import { Observable } from 'rxjs';

@Injectable()
export class AlgoliaCredentialFetcherService implements CredentialsFetcher {
  private readonly httpClient = inject(HttpClient);

  fetchCredentials(): Observable<Credentials> {
    return this.httpClient.get<Credentials>(`${environment.api.suggestion}/_credentials/algolia`);
  }
}
